import { i18n } from 'src/i18n';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';
import listActions from 'src/modules/workflowLaunch/list/workflowLaunchListActions';
import WorkflowLaunchService from 'src/modules/workflowLaunch/workflowLaunchService';
import Message from 'src/view/shared/message';

const prefix = 'WORKFLOW_LAUNCH_DESTROY';

const workflowLaunchDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: workflowLaunchDestroyActions.DESTROY_STARTED,
      });

      await WorkflowLaunchService.destroyAll([id]);

      dispatch({
        type: workflowLaunchDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.workflowLaunch.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/workflow-launch');
    } catch (error) {
      Errors.handle(error);
      dispatch(listActions.doFetchCurrentFilter());
      dispatch({
        type: workflowLaunchDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: workflowLaunchDestroyActions.DESTROY_ALL_STARTED,
      });

      await WorkflowLaunchService.destroyAll(ids);

      dispatch({
        type: workflowLaunchDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.workflowLaunch.destroyAll.success'),
      );

      getHistory().push('/workflow-launch');
    } catch (error) {
      Errors.handle(error);
      dispatch(listActions.doFetchCurrentFilter());
      dispatch({
        type: workflowLaunchDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default workflowLaunchDestroyActions;
